import React, { Fragment, useMemo, useState } from "react"

import { NewGradJobDetail } from "~/entities/NewGradJob"

import * as Styled from "./styled"

type Props = {
  schedules: NewGradJobDetail["work_schedules"]
}

export const Schedule = ({ schedules }: Props) => {
  const [isMore, setIsMore] = useState(false)

  const maybeSlicedSchedules = useMemo(() => (isMore ? schedules : schedules.slice(0, 3)), [isMore, schedules])

  return (
    <Styled.ScheduleContainer>
      {maybeSlicedSchedules.map(({ description, time, title, img_url }) => (
        <Styled.Schedule key={title}>
          <Styled.ScheduleTimeLineContainer>
            <Styled.ScheduleTimeLine />
            <Styled.ScheduleTimeLinePoint />
            <Styled.ScheduleTimeLine />
          </Styled.ScheduleTimeLineContainer>

          <Styled.ScheduleBoxContainer>
            <Styled.ScheduleBox>
              <Styled.ScheduleBoxTitle>
                <Styled.ScheduleBoxTitleTime>{time}</Styled.ScheduleBoxTitleTime>
                <Styled.ScheduleBoxTitleText>{title}</Styled.ScheduleBoxTitleText>
              </Styled.ScheduleBoxTitle>
              <Styled.ScheduleBoxDescription>
                {description.split("\n").map((text) => (
                  <Fragment key={text}>
                    {text} <br />
                  </Fragment>
                ))}
              </Styled.ScheduleBoxDescription>
            </Styled.ScheduleBox>
            {img_url && <Styled.ScheduleBoxImage alt={title} src={img_url} />}
          </Styled.ScheduleBoxContainer>
        </Styled.Schedule>
      ))}
      <Styled.ScheduleSeparate />
      {isMore || (
        <Styled.MoreButtonWrapper>
          <Styled.MoreButton isButton size="Medium" onClick={() => setIsMore(true)}>
            もっと見る
          </Styled.MoreButton>
        </Styled.MoreButtonWrapper>
      )}
    </Styled.ScheduleContainer>
  )
}
